import { Fragment } from "react";

import { getExternalLinkAttributes, getSafeHref } from "../../helpers/onboardingAgentHelpers";
import {
    ASSISTANT_LINE_SEPARATOR,
    ASSISTANT_PARAGRAPH_SEPARATOR_PATTERN,
    MARKDOWN_LINK_PATTERN,
    MARKDOWN_STRONG_PATTERN,
    MARKDOWN_TOKEN_PATTERN,
} from "../../onboardingAgentConstants";
import { onboardingAgentTrackingService } from "../../onboardingAgentTrackingService";

import { AssistantBodyParagraph, AssistantMarkdownLink, AssistantMarkdownStrong } from "../styles";

const createAssistantLinkClickHandler =
    (label: string, href: string, threadId?: string): (() => void) =>
    (): void => {
        onboardingAgentTrackingService.trackAssistantLinkClick(label, href, threadId);
    };

const renderInlineMarkdown = (text: string, keyPrefix: string, threadId?: string) =>
    text.split(MARKDOWN_TOKEN_PATTERN).map((part, index) => {
        const linkMatch = part.match(MARKDOWN_LINK_PATTERN);

        if (linkMatch) {
            const [, label, href] = linkMatch;
            const safeHref = getSafeHref(href);
            const externalLinkAttributes = getExternalLinkAttributes(safeHref);
            const handleAssistantLinkClick = createAssistantLinkClickHandler(label, safeHref, threadId);

            return (
                <AssistantMarkdownLink
                    key={`${keyPrefix}-link-${index}`}
                    href={safeHref}
                    data-automation="onboarding-agent-assistant-message-link"
                    onClick={handleAssistantLinkClick}
                    {...externalLinkAttributes}
                >
                    {label}
                </AssistantMarkdownLink>
            );
        }

        const strongMatch = part.match(MARKDOWN_STRONG_PATTERN);

        if (strongMatch) {
            return (
                <AssistantMarkdownStrong key={`${keyPrefix}-strong-${index}`}>{strongMatch[1]}</AssistantMarkdownStrong>
            );
        }

        return part;
    });

export const renderAssistantText = (text: string, threadId?: string) => (
    <>
        {text.split(ASSISTANT_PARAGRAPH_SEPARATOR_PATTERN).map((paragraph, paragraphIndex) => (
            <AssistantBodyParagraph key={`assistant-paragraph-${paragraphIndex}`}>
                {paragraph.split(ASSISTANT_LINE_SEPARATOR).map((line, lineIndex) => (
                    <Fragment key={`assistant-line-${paragraphIndex}-${lineIndex}`}>
                        {lineIndex > 0 ? <br /> : null}
                        {renderInlineMarkdown(line, `assistant-line-${paragraphIndex}-${lineIndex}`, threadId)}
                    </Fragment>
                ))}
            </AssistantBodyParagraph>
        ))}
    </>
);
